import { Row, Col } from 'antd';
import { Category1Types } from 'enums/category1Enums';
import { Formik } from 'formik';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import FieldsRow from 'shared/components/FieldsRow';
import Catgeory1Layout from 'views/Scope3/Category1/category1Layout';
import { sampleFieldsRowData } from '../fieldsRowData';
import FormikForm from '../FormikForm';
import CODateTimeField from 'shared/components/CODateTimeField';
import styles from '../appComponents.module.scss';
import { Moment } from 'moment';

interface FormValues {
  rhfInput: string;
  rhfSelect?: string;
  rhfCheckbox?: boolean;
  rhfSwitch?: boolean;
}

const DistributionFormComponent = () => {
  const [date, setDate] = React.useState<string>('');
  const [time, setTimeValue] = React.useState<string | null>(null);

  const methods = useForm<FormValues>({
    mode: 'onBlur',
    defaultValues: {
      rhfInput: '',
      rhfSelect: undefined,
      rhfCheckbox: undefined,
      rhfSwitch: undefined,
    },
  });

  return (
    <Formik
      initialValues={{
        finished_goods: {
          total_weight: 100,
          weight_transported: 10,
          weight_in_storage: 1,
          weight_sold_via_online: 10,
          products: [
            {
              id: 1,
              name: 'Test product 1',
              quantity: 10,
              unit: 'kg',
              is_transported_by_air: true,
              company_payment_percentage: 10,
              is_completely_paid_by_company: false,
              address: {
                id: 1,
                //other address related details
              },
            },
          ],
        },
      }}
      onSubmit={value => {}}>
      <FormikForm>
        <div className="mt-5">
          <h2>Date Time Field</h2>
          <div className="flex-inline" style={{ width: '400px', gap: '20px' }}>
            <CODateTimeField
              title="Select Date"
              name="date-picker01"
              placeholder="select a date"
              onChange={(v: Moment | null, _) => setDate(time?.toString ?? '')}
              value={date}
            />
            <CODateTimeField
              time
              title="Select Time"
              name="time-picker01"
              placeholder="select a date"
              onChange={(time: Moment | null, _) =>
                setTimeValue(time?.toString ?? '')
              }
              value={time}
            />
          </div>
        </div>
        <Row className={styles.fieldsRow}>
          <Col span={24}>Fields Row Implementation</Col>
          <Col span={24}>
            <FieldsRow {...sampleFieldsRowData} />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormProvider {...methods}>
              <Catgeory1Layout type={Category1Types.INGREDIENTS} index={1} />
            </FormProvider>
          </Col>
        </Row>
      </FormikForm>
    </Formik>
  );
};
export default DistributionFormComponent;
